import Vue from 'vue';
import VuejsDialog from 'vuejs-dialog';

import IdleLogout from '@/components/modals/idle_logout.vue';
import Loader from '@/components/modals/loader.vue';
import FeedbackComplete from '@/components/modals/feedback_complete.vue';
import TechnicalError from '@/components/modals/technical_error.vue';
import SessionExpiredTryAgain from '@/components/modals/session_expired_try_again.vue';
import SessionExpiredTryAgainPaynamics from '@/components/modals/session_expired_try_again_paynamics.vue';
import SessionExpiredBackToStore from '@/components/modals/session_expired_back_to_store.vue';
import SessionExpiredBackToMerchantPaynamics from '@/components/modals/session_expired_back_to_merchant.vue';
import SessionExpiredTryAgainMerchant from '@/components/modals/session_expired_try_again_merchant.vue';
import SessionExpiredBackToMerchant from '@/components/modals/session_expired_back_to_merchant.vue';

Vue.use(VuejsDialog)

Vue.dialog.registerComponent('idle-logout', IdleLogout);
Vue.dialog.registerComponent('loader', Loader);
Vue.dialog.registerComponent('feedback-complete', FeedbackComplete);
Vue.dialog.registerComponent('technical-error', TechnicalError);
Vue.dialog.registerComponent('session-expired-try-again', SessionExpiredTryAgain);
Vue.dialog.registerComponent('session-expired-try-again-paynamics', SessionExpiredTryAgainPaynamics);
Vue.dialog.registerComponent('session-expired-back-to-store', SessionExpiredBackToStore);
Vue.dialog.registerComponent('session-expired-back-to-merchant-paynamics', SessionExpiredBackToMerchantPaynamics);
Vue.dialog.registerComponent('session-expired-try-again-merchant', SessionExpiredTryAgainMerchant);
Vue.dialog.registerComponent('session-expired-back-to-merchant', SessionExpiredBackToMerchant);